/* globals lp,jui,Class */
module.exports = Class.create(
    lp.editor.panel.ElementPropertiesPanel,
    lp.editor.panel.ElementGeometryControls,
    lp.editor.panel.ElementBackgroundControlsNew,
    lp.editor.panel.ElementBorderControls,
    lp.ModuleComponent,
    {
      type:'lp-pom-box',

      installUI: function($super){
        $super();

        var geometryPanel = this.insert(new jui.CollapsiblePanel({
          title:'Geometry',
          attributes: {
            className: 'collapsible-panel panel-box-geometry'
          }}));
        this.installGeometryControls({insert:geometryPanel.insertContent.bind(geometryPanel)});
        var borderPanel = this.insert(new jui.CollapsiblePanel({
          title:'Border',
          attributes: {
            className: 'collapsible-panel panel-box-border labels-above'
          }}));
        this.installBorderControls({insert:borderPanel.insertContent.bind(borderPanel)});
        var backgroundPanel = this.insert(new jui.CollapsiblePanel({
          title:'Background',
          attributes: {
            className: 'collapsible-panel panel-box-background'
          }}));

        this.installBackgroundControls({
          insert        : backgroundPanel.insertContent.bind(backgroundPanel),
          showStretched : true,
          showFixed     : false
        });
      },

      syncUIControls: function($super, elm) {
        $super(elm);
        this.bindGeometryControlsToElement(elm);
        this.bindBackgroundControlsToElement(elm);
        this.bindBorderControlsToElement(elm);
      }
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-box/box_element_properties_panel.js
// module id = 1084
// module chunks = 0